module.exports = __webpack_public_path__ + "static/media/wrapper.d3300086.svg";